import React from "react";
import SimplePoolItem from "./SimplePoolItem";
import { useApi } from "../lib/useApi";
import { programKey } from "../lib/program";

const SimpleTodayPage = ({ pool_id }) => {
  let start_term = "";
  let end_term = "";
  switch (pool_id) {
    case 6:
      start_term = "S6 ";
      end_term = "S7 ";
      break;
    case 10:
      start_term = "S10 ";
      end_term = "S11 ";
      break;
    case 13:
      start_term = "S13 ";
      end_term = "S13A ";
      break;
    case 4:
      start_term = "S4 ";
      end_term = "S5 ";
      break;
    case 16:
      start_term = "S13X ";
      end_term = "S13Y ";
      break;
    default:
      start_term = "Error ";
      end_term = "Error ";
  }

  const { data } = useApi(`/api/GetFullPools/${start_term}/${end_term}`, {
    select: (json) => {
      // Get today's date in YYYY-MM-DD format for comparison
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0];

      // Filter pools to only include those with programDate matching today
      const temp = [];
      for (const pool of json.value) {
        const poolDate = new Date(pool.programDate).toISOString().split('T')[0];
        if (poolDate === todayStr) {
          temp.push(pool);
        }
      }

      temp.sort((a, b) => {
        if (a.RowKey < b.RowKey) return -1;
        if (a.RowKey > b.RowKey) return 1;
        return a.programCode.localeCompare(b.programCode);
      });

      return temp;
    },
  });
  const Pools = data ? data : [];
  const PoolVolume = data ? data.length : -1;

  return (
    <div style={{ padding: "2px", backgroundColor: "white" }}>
      {PoolVolume === 0 && <div className="panel">No pool currently open.</div>}
      {Pools.map((item) => (item.race !== "-1" ? <SimplePoolItem key={programKey(item)} item={item} /> : null))}
    </div>
  );
};

export default SimpleTodayPage;
